import { createFetcher } from './fetcher'

const fetcherInstance = createFetcher()
export const { fetcher, setAuthorization, setRequestHeaders, removeAuthorization } = fetcherInstance
